"use strict";

require("core-js/modules/es6.promise");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var ProductSelectors_1 = require("./Product/ProductSelectors");
var Events_1 = require("Core/Events");
var CommonFunctions_1 = require("./CommonFunctions");
var Languages_1 = require("Core/Languages");
var Responsiveness_1 = require("Core/Responsiveness");
exports.CategoryDescription = function () {
  Events_1.onLoad(hidelongDescription);
  Events_1.onClick(ProductSelectors_1.Selectors.CAT_TITLE.BTN, toggleDescription);
  function hidelongDescription() {
    var image = new Promise(function (resolve, reject) {
      var image = new Image();
      var img = document.querySelector('.category_main_img');
      if (img != null) {
        image.src = img.src;
      }
      image.onload = function () {
        return resolve(image);
      };
    });
    image.then(function () {
      if ($(ProductSelectors_1.Selectors.CAT_TITLE.TEXT).length > 0 && $(ProductSelectors_1.Selectors.CAT_IMAGE).length > 0 && Responsiveness_1.ActualScreen.WIDTH >= Responsiveness_1.Breakpoints.XL) {
        var img_height = CommonFunctions_1.getInnerHeight($(ProductSelectors_1.Selectors.CAT_IMAGE));
        var component_text_height = CommonFunctions_1.getOuterHeightofElement($(ProductSelectors_1.Selectors.CAT_TITLE.COMPONENT));
        var final_target_value = calcDescriptionHeight();
        if (component_text_height > img_height) {
          $(ProductSelectors_1.Selectors.CAT_TITLE.COMPONENT).addClass('truncated_version').css({
            'height': final_target_value + "px",
            'overflow': 'hidden'
          });
          $(ProductSelectors_1.Selectors.CAT_TITLE.BTN).show();
        }
      }
    });
  }
  function calcDescriptionHeight() {
    var img_height = CommonFunctions_1.getInnerHeight($(ProductSelectors_1.Selectors.CAT_IMAGE));
    var title_height = CommonFunctions_1.getOuterHeightofElement($(ProductSelectors_1.Selectors.CAT_TITLE.TITLE));
    var component_text_height = CommonFunctions_1.getOuterHeightofElement($(ProductSelectors_1.Selectors.CAT_TITLE.COMPONENT));
    var line = parseFloat($(ProductSelectors_1.Selectors.CAT_TITLE.TEXT).css('line-height'));
    var component_height_target = component_text_height - (component_text_height - img_height) - title_height - line;
    var temp_modulo = component_height_target % line;
    var final_target_value = component_height_target - temp_modulo + title_height;
    return final_target_value;
  }
  function toggleDescription() {
    var text;
    if ($(ProductSelectors_1.Selectors.CAT_TITLE.COMPONENT).hasClass('truncated_version')) {
      $(ProductSelectors_1.Selectors.CAT_TITLE.COMPONENT).removeClass('truncated_version').css({
        'height': 'auto',
        'overflow': 'hidden'
      });
      switch (Languages_1.getCurrentLanguage) {
        case 'pl':
          text = '...mniej';
          break;
        case 'ru':
          text = '...Меньше';
          break;
        default:
          text = '...less';
      }
    } else {
      var final_target_value = calcDescriptionHeight();
      $(ProductSelectors_1.Selectors.CAT_TITLE.COMPONENT).addClass('truncated_version').css({
        'height': final_target_value + "px",
        'overflow': 'hidden'
      });
      switch (Languages_1.getCurrentLanguage) {
        case 'pl':
          text = '...więcej';
          break;
        case 'ru':
          text = '...Больше';
          break;
        default:
          text = '...more';
      }
    }
    $(ProductSelectors_1.Selectors.CAT_TITLE.BTN).text(text);
  }
}();